<footer [ngClass]="{ business: corpPartner.updateBgColor || businessUser }">
  <div
    *ngIf="isDarkSiteEnabled && !isLightFooterEnable"
    [ngClass]="{ 'd-sm-none d-md-none d-lg-none d-none': isLightFooterEnable }"
    class="hp-footer bg-dark-footer"
  >
    <div class="container">
      <div
        *ngIf="
          contentSearch?.placeHolder &&
          defaultFooter &&
          enableSearch &&
          !hideSearchButton
        "
        class="footer-search-container text-md-center"
      >
        <div class="row">
          <div class="col-md-12 footer-search-topic">
            <a
              (click)="footerSearch?.open()"
              class="search-text"
              href="javascript:void(0);"
            >
              {{
                contentSearch && contentSearch.placeHolder
                  ? contentSearch.placeHolder
                  : ''
              }}
              <ngc-search
                #footerSearch
                (modalServiceRef)="saveModalServiceRef($event)"
                [avoidFocus]="true"
                [modalPosition]="'modal-center'"
                [origin]="'footer'"
              ></ngc-search>
            </a>
          </div>
        </div>
        <!-- Popular Topic row  -->
        <div
          *ngIf="popularTopic"
          class="d-flex d-flex-wrap justify-content-center d-sm-none d-md-flex footer-popular-topic"
        >
          <div class="footer-list-container">
            <h3>{{ popularTopic.heading }}</h3>
            <ul class="list-inline popular-list">
              <li
                *ngFor="
                  let topic of popularTopic.popularTopicsList;
                  let last = last;
                  let i = index
                "
                class="list-inline-item"
              >
                <a
                  (click)="setTrackingObject(topic.itemtext)"
                  [attr.href]="topic ? topic.itemUrl : '#'"
                  [attr.target]="
                    topic ? (topic.newwindow === 'true' ? '_blank' : '') : ''
                  "
                  class="popular-list-{{ i + 1 }}"
                >
                  {{ topic ? topic.itemtext : '' }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr *ngIf="enableSearch" class="d-none d-md-block" />
      <div *ngIf="defaultFooter" class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 footer-column-container">
          <ngc-footer-column></ngc-footer-column>
        </div>
      </div>
      <!-- footer information starts-->
      <div class="text-md-center">
        <div class="row">
          <div class="col-md-12">
            <ngc-information></ngc-information>
          </div>
        </div>
      </div>
      <!-- footer information ends-->
      <!-- footer bottom starts-->
      <div class="row">
        <div
          [ngClass]="{
            'extra-margin':
              contentFooter &&
              (!contentFooter.feedback ||
                !contentFooter.social ||
                !contentFooter.countryLanguage)
          }"
          class="col-lg-12 col-md-12"
        >
          <div
            [ngClass]="{
              'footer-bottom-rows': !additionalInfo
            }"
            class="row footer-bottom no-gutters"
          >
            <!--Social media icons starts-->
            <div
              *ngIf="contentFooter?.social"
              [ngClass]="{
                'col-12 m-auto text-center text-md-center ':
                  contentFooter &&
                  !contentFooter.countryLanguage &&
                  !contentFooter.feedback,
                'ml-md-auto col-6 pad-rt-20 border-right':
                  contentFooter && contentFooter.feedback,
                'col-12 text-center col-md-4 col-lg-5 ':
                  contentFooter &&
                  contentFooter.countryLanguage &&
                  !contentFooter.feedback
              }"
              class="p-0 text-md-right d-sm-inline-block d-md-block border-right-social-icons"
            >
              <ngc-social-icons></ngc-social-icons>
            </div>
            <!--Social media icons ends-->
            <!--Website feedback icons starts-->
            <div
              *ngIf="contentFooter?.feedback"
              [ngClass]="{
                'col-sm-12':
                  contentFooter &&
                  !contentFooter.countryLanguage &&
                  !contentFooter.social,
                'mr-md-auto col-md-6 col-lg-6 col-xl-6':
                  contentFooter &&
                  (!contentFooter.countryLanguage || !contentFooter.social),
                'ml-md-auto':
                  contentFooter &&
                  !contentFooter.countryLanguage &&
                  !contentFooter.social,
                'text-sm-left text-md-right':
                  contentFooter && !contentFooter.social,
                'text-md-left': contentFooter && !contentFooter.countryLanguage,
                'text-sm-right':
                  (contentFooter &&
                    contentFooter.countryLanguage &&
                    contentFooter.social) ||
                  !contentFooter.countryLanguage,
                'text-md-center':
                  (contentFooter &&
                    contentFooter.countryLanguage &&
                    contentFooter.social) ||
                  (!contentFooter.countryLanguage && !contentFooter.social),
                'text-sm-center':
                  contentFooter &&
                  !contentFooter.countryLanguage &&
                  !contentFooter.social,
                'pad-rt-20':
                  contentFooter &&
                  !contentFooter.social &&
                  contentFooter.countryLanguage,
                'pad-lt-30':
                  contentFooter &&
                  contentFooter.social &&
                  !contentFooter.countryLanguage
              }"
              class="col-md-4 col-lg-3 col-xl-2 col-sm-6 p-0"
            >
              <ngc-feedback></ngc-feedback>
            </div>
            <!--Website feedback icons ends-->
            <!--Language selector starts-->
            <div
              *ngIf="contentFooter?.countryLanguage"
              [ngClass]="{
                'mt-sm-0':
                  contentFooter &&
                  (!contentFooter.feedback || !contentFooter.social),
                'mr-md-auto col-md-8 col-lg-6 col-xl-6':
                  contentFooter &&
                  (!contentFooter.social || !contentFooter.feedback),
                'ml-md-auto pl-md-0  text-md-center':
                  contentFooter &&
                  !contentFooter.social &&
                  !contentFooter.feedback,
                'pad-lt-30 footer-padding-top':
                  contentFooter &&
                  ((contentFooter.social && !contentFooter.feedback) ||
                    (!contentFooter.social && contentFooter.feedback)),
                'cls-disable': isBAUOrStaticPg
              }"
              class="col-12 text-center col-lg-5 col-xl-5 text-md-left language-selector-outer"
            >
              <ngc-language-selector></ngc-language-selector>
              <!-- <button (click)="$event.preventDefault();openWidget('book');" class="d-none d-lg-block external-wiget-trigger">book</button>-->
            </div>
            <!--Language selector ends-->
          </div>
        </div>
      </div>
      <!-- Footer additional info starts -->
      <hr *ngIf="additionalInfo" class="d-none d-md-block" />
      <div class="row" *ngIf="additionalInfo">
        <div class="text-md-center mb-5 footer-info">
          <p [innerHTML]="additionalInfo"></p>
        </div>
      </div>
      <!-- Footer additional info ends -->
      <!--Language selector ends-->
    </div>
  </div>
  <div *ngIf="isLightFooterEnable" class="hp-footer bg-dark-footer">
    <div class="container">
      <div class="text-md-center">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-info">
              <p>
                {{
                  contentFooter
                    ? contentFooter.info.copyRight
                    : '�2017 Delta Air Lines, Inc.'
                }}
              </p>
            </div>
            <!--<ngc-information></ngc-information>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <ngc-cookie-banner></ngc-cookie-banner> -->
</footer>
